/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	Optional,
	Output,
	Self,
	ChangeDetectorRef,
} from '@angular/core';
import { TicketEditBaseComponent } from '../../../modules/ticket-edit/components/ticket-edit-base/ticket-edit-base.component';
import { NgControl } from '@angular/forms';
import { MultiWrapperComponent } from '../../../modules/ticket-edit/components/multi-wrapper/multi-wrapper.component';
import { TicketType } from '@touchplan/common';
import { CommonModule } from '@angular/common';

/**
 * This component displays ticket related icons.  The only supported
 * icon currently is the promise pin.
 */
@Component({
	selector: 'ticket-promise-icon',
	templateUrl: './ticket-promise-icon.component.html',
	styleUrls: ['./ticket-promise-icon.component.scss'],
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketPromiseIconComponent extends TicketEditBaseComponent {
	@Input() public totalPins = 0;
	@Input() public color = '#000000';
	@Input() public missedCount = 0;
	@Input() public ticketType: TicketType = TicketType.Task;
	@Input() public disabled = false;
	@Output() public clicked: EventEmitter<any> = new EventEmitter();

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef
	) {
		super(control, multiWrapper, cd);
	}

	public onIconClicked(event): void {
		if (this.disabled) {
			return;
		}
		this.clicked.emit(event);
	}
}
